import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Typography, BasicButton } from '../../components/atoms';
import DownloadIcon from '../../assets/icons/download.svg';

const DownloadButton = styled(BasicButton)`
    background: #fff;
    border: 1px solid #d1d5db;
    color: #222;
    font-weight: 500;
    border-radius: 8px;
    padding: 0 8px !important;
    height: 28px;
    font-size: 12px;
    min-width: 0;
    box-shadow: none;
    text-transform: none;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none !important;
    &:hover {
        background: #f5f6fa;
        border-color: #bfc5d2;
        text-decoration: none !important;
        color: #222 !important;
    }
    .download-icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
        display: inline-block;
        vertical-align: middle;
    }
`;

interface PortfolioApprovalDetailsProps {
    // Add your props here
    id: string;
    date: string;
    tenant: string;
    property: string;
    fundTypes: string;
    portfolioType: string;
    fileName: string;
    fileId: string;
    submitter: string;
    userId: string;
    onApprove: () => void;
    onReject: () => void;
    expanded?: boolean;
    onExpand?: () => void;
    onDownload?: () => void;
    goalCategory?: string;
    portfolioBundleName?: string;
}

const PortfolioApprovalDetails: React.FC<PortfolioApprovalDetailsProps> = ({
    property,
    fundTypes,
    portfolioType,
    fileName,
    onDownload,
    goalCategory,
    portfolioBundleName,
    tenant
}) => {
    const { t } = useTranslation();

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', mb: 1.5 }}>
                <Typography variant="body2" sx={{ minWidth: 275 }}>
                    <b>{t('LABELS_CHECK_MAKER_PROPERTY')}:</b> {property}
                </Typography>
                <Typography variant="body2" sx={{ minWidth: 275, paddingRight: 32 }}>
                    <b>{t('LABELS_CHECK_MAKER_FUND_TYPES')}:</b> {t(fundTypes)}
                </Typography>
                {tenant == 'banortemex' && goalCategory && (
                    <Typography variant="body2" sx={{ minWidth: 275, paddingRight: 32 }}>
                        <b>{t('GOAL_TYPE').slice(0, -1)}:</b> {goalCategory}
                    </Typography>
                )}
                {tenant == 'banortemex' && portfolioBundleName && (
                    <Typography variant="body2" sx={{ minWidth: 275, paddingRight: 32 }}>
                        <b>{t('PORTFOLIO_BUNDLE').slice(0, -1)}:</b> {portfolioBundleName}
                    </Typography>
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                <Typography variant="body2" sx={{ minWidth: 275 }}>
                    <b>{t('LABELS_CHECK_MAKER_WEIGHTS_UPDATED')}: </b>
                    {t(portfolioType)}
                </Typography>
                <Typography variant="body2" sx={{ minWidth: 275, paddingRight: 32 }}>
                    <b>{t('LABELS_CHECK_MAKER_PORTFOLIO')}:</b> {fileName}
                </Typography>
                <DownloadButton size="small" onClick={onDownload} sx={{ ml: 0, p: 0 }} disableElevation>
                    <img
                        src={DownloadIcon}
                        alt={t('LABELS_CHECK_MAKER_DOWNLOAD_EXCEL_FILE')}
                        className="download-icon"
                    />
                    {t('LABELS_CHECK_MAKER_DOWNLOAD_EXCEL_FILE')}
                </DownloadButton>
            </Box>
        </>
    );
};

export default PortfolioApprovalDetails;
